import { useState } from "react";
import { api } from "./api.ts";
import { ReportThis } from "./ReportThis.tsx";
import { Button } from "./souvenir.ts";

// Each member allows their own (features/sharing.md): once a trip is shared to view, everyone in it but its owner is
// asked, on the trip and on Your trips (and once by email), whether viewers see their name, photo and ratings. Nothing
// of theirs shows until they choose Show them; either answer can be changed in Trip settings. `trip` names it on Your
// trips, where several trips may ask.
export function ViewersAsk({ trip, title, onAnswered }: { trip: string; title?: string; onAnswered: () => void }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const answer = async (show: boolean) => {
    setBusy(true);
    setError(null);
    try {
      await api.shareMine(trip, show);
      onAnswered();
    } catch (e) {
      setError(e instanceof Error ? e.message : "That didn't work. Try again.");
      setBusy(false);
    }
  };
  return (
    <aside className="tm-viewers-ask" aria-label="Shared to view">
      <div className="tm-viewers-ask-text">
        <h2 className="callout tm-viewers-ask-title">
          {title ? `${title} is shared to view` : "This trip is shared to view"}
        </h2>
        <p className="caption tm-muted">
          Show your name, photo and ratings to the people it's shared with? Until you do, they see you as "A traveller".
        </p>
      </div>
      <div className="tm-viewers-ask-actions">
        <Button variant="primary" size="sm" disabled={busy} onClick={() => answer(true)}>
          Show them
        </Button>
        <Button variant="quiet" size="sm" disabled={busy} onClick={() => answer(false)}>
          Keep them hidden
        </Button>
      </div>
      {error && (
        <p className="callout tm-error" role="alert">
          {error}
          <ReportThis />
        </p>
      )}
    </aside>
  );
}
